<template>
  <div id="printableArea" dir="rtl" >
    <button class="btn no-print float-left" @click="$router.go(-1)">بازگشت</button>
    <div class="container-fluid pt-4 " >

      <div class="row p-3 mx-1">
        <div class="col-5 p-0">
          <!-- <img src="/assets/pics/Logo.png" alt="Logo" style="max-width: 100%" /> -->
          <img src="@/assets/images/print_export_pricelist1.jpg" alt="Logo" class="header-image" />
        </div>
        <div class="col-md-8 col-12 text-center">
          <span class="mb-2 font-weight-bold mr-5 d-block" style="font-size: 20px"></span>
        </div>
        <div class="col-2"></div>
        <div class="col-md-12 col-12 text-center">
          <span class="float-left">
            <small> شماره سریال : {{ printItem.serial }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <small> تاریخ : {{ $GetJalaliDate() }}</small><span></span>
          </span>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <p>
          با سلام ، احتراماً لیست قیمت و سامانه ها اختیاري آن در جدول زیر آمده
          است،
          خواهشمند است از لیست زیر سامانه هاي مورد نظر را انتخاب نمایید تا پیش فاکتور خدمتتان ارائه گردد.
        </p>
      </div>

      <div class="row">

        <table class="w-100 p-0">

          <thead class="text-center">
            <tr>
              <td>نوع</td>
              <td>شرح</td>
              <td>قیمت (ریال)</td>
            </tr>
          </thead>

          <tbody v-if="render">

            <tr v-for="item in printItem.tblCustomerPriceListDetail" >

              <td style="width: 20%;" class="text-center" :class="[item.tblPriceListMaster.isOptional ? ['title-opt'] : ['title']]" >
                {{item.nameProduct}}
              </td>

              <td class="table-price text-center" style="width: 65%;">
                <p>{{ item.des == "" || null ? '-' : item.des }}</p>
              </td>

              <td class="table-price text-center" style="width: 15%;">
                <p>{{ item.totallAmount }}</p>
              </td>
            </tr>
            <!-- <tr>
              <td style="width: 10%;" class="title text-center">
                نرم افزار تعاونی اعتبار
              </td>
              <td class="p-0 table-price" style="width: 80%;">
                <p>هر کاربر اضافه</p>
                <div class="line"></div>
                <p>هر کاربر اضافه</p>
                <div class="line"></div>
                <p>هر کاربر اضافه</p>
                <div class="line"></div>
                <p>هر کاربر اضافه</p>
              </td>

              <td class="p-0 table-price text-center" style="width: 10%;">
                <p>680,000</p>
                <div class="line"></div>
                <p>680,000</p>
                <div class="line"></div>
                <p>680,000</p>
                <div class="line"></div>
                <p>680,000</p>
              </td>

            </tr> -->

          </tbody>

        </table>
        <div class="border-footer w-100">

          <div v-for="de in des" class=" w-100 p-2 ">
            <div>
              <p v-text="de" class="mt-2" v-if="de != ''">
                <!-- <span>(اعتبار تا پایان آذر 1401)</span> -->
              </p>
            </div>
          </div>
          <!-- <div class=" w-100 p-2">
            <div>
              <p class="mt-2">
                ● موارد ستاره دار ( *) به صورت اشتراك یکساله ارائه شده و پس از یکسال نیاز به تمدید مجدد دارد.
              </p>
            </div>
          </div>
          <div class=" w-100 p-2 ">
            <div>
              <p class="mt-2">
                ● با انتخاب همزمان سامانه همپا و نتپا ، سامانه USSD به صورت <span
                  style="color:red !important">رایگان</span> هدیه خواهد شد.
              </p>
            </div>
          </div>
          <div class=" w-100 p-2 ">
            <div>
              <p class="mt-2" style="color:red !important">
                ● 10 %تخفیف با پرداخت نقدي کل مبلغ فاکتور
              </p>
            </div>
          </div> -->
        </div>

      </div>

      <div>
        <!-- <button class="btn" style="background-color: #21ae8c !important;width:90px;">چاپ</button> -->

      </div>

      <div class="fixed-bottom container-fluid row">

        <img src="@/assets/images/print_export_pricelist2.jpg" class="footer-image">

        <!-- <div class="row text-center">
          <div class="col-4">
            <i class=""></i>
            INFO@BNPCO.IR
          </div>
          <div class="col-4">
            WWW.BNPCO.IR

          </div>
          <div class="col-4">
            09129052758
          </div>
        </div> -->

      </div>

    </div>

  </div>
</template>
<script>

export default {
  data() {
    return {
      item: this.$route.params.item,
      data: {},
      printItem: {},
      render: true,
      des:''
    }
  },

  mounted() {
    this.des = this.item.printDes.split('\n')
    let dataaxios = {
      Action: "PriceList/GetPriceListPrint/" + this.item.id,
      Method: "Get",
    }
    this.$PostData(dataaxios)
      .then((response) => {

        this.printItem = response
        this.printItem.tblCustomerPriceListDetail.forEach((el)=>{
          el.totallAmount = this.$Comma3ragham(el.totallAmount)
        })

        this.render = false
        this.$nextTick(() => {
          this.render = true
        })
  

      }).catch((error) => {
        console.error("CATCH", error);
      })

  },

}
</script>
<style scoped>
table,
th,
td {
  border: 1px solid rgb(63, 62, 62);
}

.border-footer {
  border: 1px solid black;
  background-color: yellow;
  line-height: 3px;
}

.line {
  height: 1px;
  background-color: black;
  width: 100%;
  line-height: 0px;
}

.table-price p {
  padding: 10px 10px 10px 0px;
  line-height: 0px;
  margin-top: 2px;
}

.table-price {
  line-height: 0px;
}

@media print {
  .no-print {
    display: none;
  }
}

.header-image{
  width: 70%;
  height: 150px;
}

.footer-image{
  width: 100%;
  height: 70px;
}

.title {
  background-color: greenyellow;
}
.title-opt {
  background-color: aquamarine;
}

*{
  font-size: 18px !important;
}
</style>
  